module.exports = __webpack_public_path__ + "2c4e1d6f01eb9e3eefffe64f7f3d893b.pdf";